import { render, staticRenderFns } from "./btnrnd.vue?vue&type=template&id=1965a764&scoped=true"
import script from "./btnrnd.vue?vue&type=script&lang=js"
export * from "./btnrnd.vue?vue&type=script&lang=js"
import style0 from "./btnrnd.vue?vue&type=style&index=0&id=1965a764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1965a764",
  null
  
)

export default component.exports